export const SearchLayout = [
    {
        "groupId": 1,
        "fields": [
            {
                "name": "rateCode",
                "tableName": "WMRATETABLEHEADER",
                "label": "Rate Code",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "fields": [
            {
                "name": "description",
                "tableName": "WMRATETABLEHEADER",
                "label": "Description",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
];

export const PrimaryLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "RECORD",
                "localizedField": "KEYSEQUENCE",
                "tableName": "WMRATETABLEHEADER",
                "label": "Record #",
                "type": "text",
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": false,
            },
            {
                "name": "RATECODE",
                "tableName": "WMRATETABLEHEADER",
                "label": "Rate Code",
                "type": "text",
                "required": true,
                "maxLength": 10,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DESCRIPTION",
                "tableName": "WMRATETABLEHEADER",
                "label": "Description",
                "type": "text",
                "required": false,
                "maxLength": 40,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "STATUS",
                "tableName": "WMRATETABLEHEADER",
                "label": "Status",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "COMMENT",
                "tableName": "WMRATETABLEHEADER",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
];
